import React from 'react'
import styles from './Hero.module.scss'

export const HeroPrompt: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p className={styles.prompt}>{children}</p>
)

export const HeroTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <h1 className={styles.title}>{children}</h1>
)

export const HeroAccent: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span className={styles.accent}>{children}</span>
)

export const HeroLead: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p className={styles.lead}>{children}</p>
)
